/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Vendor_ReturnsInputs */

const en_nav_vendor_returns = /** @type {(inputs: Nav_Vendor_ReturnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendor returns`)
};

/**
* | output |
* | --- |
* | "Vendor returns" |
*
* @param {Nav_Vendor_ReturnsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_vendor_returns = /** @type {((inputs?: Nav_Vendor_ReturnsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Vendor_ReturnsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_vendor_returns(inputs)
});